import { createAction } from 'redux-actions'
import {
  CREATE_FILE_METADATA_FAILED,
  CREATE_FILE_METADATA_SUCCEEDED,
  CREATE_FILE_METADATA,
  FETCH_S3_PRESIGNED_URLS,
  FETCH_S3_PRESIGNED_URLS_SUCCEEDED,
  INCREMENT_LAST_UPLOAD_ID,
  RESET_FILE_UPLOAD_STORE,
  UPLOAD_ATTACHMENTS,
  UPLOAD_ATTACHMENTS_FAILED,
  UPLOAD_ATTACHMENTS_SUCCEEDED,
  UPLOAD_FILES_FAILED,
  UPLOAD_FILES_PROGRESS,
  UPLOAD_FILES_SUCCEEDED,
  UPLOAD_FILES,
} from 'Redux/Types/UploadFileTypes'

export const createFileMetadata = createAction(CREATE_FILE_METADATA)
export const createFileMetadataFailed = createAction(CREATE_FILE_METADATA_FAILED)
export const createFileMetadataSucceeded = createAction(CREATE_FILE_METADATA_SUCCEEDED)

export const fetchS3PresignedURLs = createAction(FETCH_S3_PRESIGNED_URLS)
export const fetchS3PresignedURLsSucceeded = createAction(FETCH_S3_PRESIGNED_URLS_SUCCEEDED)

export const incrementLastFileID = createAction(INCREMENT_LAST_UPLOAD_ID)
export const resetFileUploads = createAction(RESET_FILE_UPLOAD_STORE)

export const uploadFiles = createAction(UPLOAD_FILES)
export const uploadFilesFailed = createAction(UPLOAD_FILES_FAILED)
export const uploadFilesProgress = createAction(UPLOAD_FILES_PROGRESS)
export const uploadFilesSucceeded = createAction(UPLOAD_FILES_SUCCEEDED)

export const uploadAttachments = createAction(UPLOAD_ATTACHMENTS)
export const uploadAttachmentsFailed = createAction(UPLOAD_ATTACHMENTS_FAILED)
export const uploadAttachmentsSucceeded = createAction(UPLOAD_ATTACHMENTS_SUCCEEDED)
